export default __webpack_public_path__ + "static/media/c5a2f50914002322831f72d576f32ea6.svg";